window.SwymWishlist = window.SwymWishlist || {};

SwymWishlist.state = {
  products: [],
  isSharedView: false
};

SwymWishlist.init = function(config) {
  SwymWishlist.translations = config.translations || {};
  SwymWishlist.shareTitle = config.shareTitle || 'Wishlist';
  SwymWishlist.priceFromTemplate = config.priceFrom || 'From %%PRICE%%';

  function initWishlist(swat) {
    const urlParams = new URLSearchParams(window.location.search);
    const sharedListId = urlParams.get('lid');
    const sharedProducts = urlParams.get('shared');

    if (sharedListId) {
      SwymWishlist.state.isSharedView = true;
      const shareBlock = document.querySelector('.swym-wishlist__share');
      swat.fetchWrtEventTypeET({
        lid: sharedListId,
        fetchfromserver: true
      }, function(products) {
        if (shareBlock) {
          shareBlock.style.display = 'none';
        }
        SwymWishlist.renderWishlist(products || []);
      }, function(err) {
        swat.fetch(SwymWishlist.renderWishlist);
      });
    } else if (sharedProducts) {
      const parsedHandles = SwymWishlist.parseSharedProducts(sharedProducts);
      if (parsedHandles && parsedHandles.length > 0) {
        SwymWishlist.loadSharedProducts(parsedHandles, SwymWishlist.renderWishlist);
      } else {
        swat.fetch(SwymWishlist.renderWishlist);
      }
    } else {
      swat.fetch(SwymWishlist.renderWishlist);
    }

    SwymWishlist.initShareButtons(SwymWishlist.shareTitle);
  }

  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(initWishlist);

  if (window._swat) {
    initWishlist(window._swat);
  }
};
